(function () {
  function isApp() {
    return !!(
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.hanntoJsBridge
    ) || typeof hanntoJsBridge !== 'undefined';
  }

  function initNavBar() {
    var bar = document.getElementById('customNavBar');
    var back = document.getElementById('customNavBarBack');
    if (!bar || !back) return;
    if (isApp()) bar.classList.add('custom-nav-bar--jsbridge');
    back.addEventListener('click', function () {
      if (
        window.HanntoJsBridge &&
        ((window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.hanntoJsBridge) ||
          typeof hanntoJsBridge !== 'undefined')
      ) {
        HanntoJsBridge.close({ url: window.location.href, method: 'GET' }).catch(function () {
          history.back();
        });
      } else {
        history.back();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavBar);
  } else {
    initNavBar();
  }
})();
